import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../apis/api/config';
import './Footer.css';
import eliteLogo from '../elitebg1_new.png';

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState('idle');
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/dashboard'; // idle | loading | success | error

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!newsletterEmail || !/\S+@\S+\.\S+/.test(newsletterEmail)) {
      setNewsletterStatus('error');
      return;
    }
    setNewsletterStatus('loading');
    try {
      const { data } = await axios.post(baseUrl + 'newsletter/subscribe', { email: newsletterEmail });
      if (data.status === 'success') {
        setNewsletterStatus('success');
        setNewsletterEmail('');
        setTimeout(() => setNewsletterStatus('idle'), 4000);
      } else {
        setNewsletterStatus('error');
      }
    } catch (err) {
      setNewsletterStatus('error');
    }
  };

  return (
    <footer className="footer-professional">

      {/* Main Footer Content - hidden on home page */}
      {!isHomePage && (
        <div className="footer-content">
          <div className="container">
            <div className="footer-grid">
              {/* Brand Column */}
              <div className="footer-column footer-brand-col">
                <div className="footer-logo-section">
                  <div className="footer-logo-bg">
                    <img src={eliteLogo} alt="EFFN Logo" className="footer-logo-img" />
                  </div>
                </div>
                <p className="footer-brand-description">
                  Our global reach, combined with local expertise, ensures that your goods are transported safely, on time, every time.
                </p>
              </div>

              {/* Company Column */}
              <div className="footer-column">
                <h4 className="footer-heading">Company</h4>
                <ul className="footer-link-list">
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/events">Events</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>

              {/* Contact Column */}
              <div className="footer-column">
                <h4 className="footer-heading">Contact</h4>
                <div className="footer-contact-info">
                  <div className="contact-item">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <span> +971 585829178 , +971 585882917</span>

                  </div>
                  <div className="contact-item">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    <span>info@effnetwork.com</span>
                  </div>
                  <div className="contact-item">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    <span>Ajman Free Zone, Office – C1 – 1F – SF13979, P.O. Box: 932, Ajman, UAE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Newsletter Bar - Full Width above footer bottom */}
      <div className="footer-newsletter-bar">
        <div className="container">
          <div className="newsletter-bar-inner">
            <div className="newsletter-bar-left">
              <h4>Join The Newsletter</h4>
              <p>Stay updated with the latest news and events from EFFN.</p>
            </div>
            <form className="newsletter-bar-form" onSubmit={handleNewsletterSubmit}>
              <div className="newsletter-bar-wrap">
                <input
                  type="email"
                  placeholder="Enter your email here"
                  value={newsletterEmail}
                  onChange={(e) => { setNewsletterEmail(e.target.value); setNewsletterStatus('idle'); }}
                  className="newsletter-bar-input"
                />
                <button type="submit" className="newsletter-bar-btn" disabled={newsletterStatus === 'loading'}>
                  {newsletterStatus === 'loading' ? (
                    <span className="newsletter-spinner" />
                  ) : newsletterStatus === 'success' ? '✓ Subscribed!' : 'Subscribe'}
                </button>
              </div>
              {newsletterStatus === 'error' && (
                <p className="newsletter-error">Please enter a valid email address.</p>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {new Date().getFullYear()} Elite Freight Forwarders Network. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <Link to="/privacy">Privacy Policy</Link>
              <span className="divider">|</span>
              <Link to="/terms">Terms of Service</Link>
            </div>
            <div className="footer-social-links">
              <a href="https://www.linkedin.com/company/elite-freight-forwarders-network/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              <a href="https://www.instagram.com/effnetwork/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm5 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm4.75-2.75a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61590364114523" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a href="https://x.com/NetworkEffn" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="X (Twitter)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              {/* https://www.facebook.com/profile.php?id=61578457891412 */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
